import { render, staticRenderFns } from "./order-tab.vue?vue&type=template&id=27a503c5&scoped=true&"
import script from "./order-tab.vue?vue&type=script&lang=js&"
export * from "./order-tab.vue?vue&type=script&lang=js&"
import style0 from "./order-tab.vue?vue&type=style&index=0&id=27a503c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a503c5",
  null
  
)

export default component.exports